.searchHistoryResults {
  .searchHistoryResultsHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }

  .title {
    font: var(--font-heading-xs-bold);
    color: var(--primitives-colors-neutral-0);
  }

  .searchHistoryResultsList {
    margin: 0 -24px;

    .phone &,
    .tablet & {
      margin: 0 -16px;
    }
  }

  .profileCardFollowBtnWrap {
    flex: auto;
    justify-content: flex-start;
  }

  .clearAllBtn {
    all: unset;
    color: var(--semantic-colors-typography-faded);
    font: var(--font-body-sm-medium);
    cursor: pointer;
    text-decoration: underline;
  }
}